import * as React from "react";
import dayjs from "dayjs";

import { Box, Grid, Stack, Typography } from "@mui/material";

import CustomInput from "../../../../helper-components/input/CustomInput";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { validateRow } from "../../../../helper-functions/validation/objectValidation";
import { addFormToObj, setInsertObjectState, setValue } from "../../../../helper-functions/shared/miscUtils";
import { IS_COOKIE_VALID, COOKIE_VALIDATION } from "../../../../helper-functions/validation/cookieValidation";

import { getLanguage } from "../../../../config/language/language";
import { ROLE_TYPES, COOKIE_REQUEST_OBJECT, COOKIE_TYPES } from "../../../../config/constants/Constants";

/**
 * A form to update a cookie.
 */
export default function CookieEditForm(props) {
    // Because modals don't re-render if the props' state changes, use a callback.
    const { callback, row: existingRow = {} } = props;

    const object = COOKIE_REQUEST_OBJECT;
    const validation = COOKIE_VALIDATION;
    const isValid = IS_COOKIE_VALID;

    const [row, setRow] = React.useState(addFormToObj(JSON.parse(JSON.stringify(object))));

    // Initialize the temporary row object with existing values.
    React.useEffect(() => {
        const newRow = {
            ...row,
            ...existingRow,

            // Convert to dayjs format if datetime exists.
            created_on: existingRow.created_on ? dayjs(existingRow.created_on) : null,

            form: {
                ...row.form,
                ...existingRow.form,
                saved: false // Required to allow editing input fields.
            }
        };

        setInsertObjectState(setRow, newRow);
    }, []);

    /**
     * Executed when typing something into an input field.
     */
    const onChange = (obj, key, value) => {
        const newCookie = JSON.parse(JSON.stringify(row));
        setValue(newCookie, key, value);

        if (key === "_role") {
            const role = ROLE_TYPES.find((r) => r.role === value);
            setValue(newCookie, "role_id", role?.id);
        }

        validateRow(obj, validation, newCookie, ["text"]);
        setInsertObjectState(setRow, newCookie);
    };

    const handleClick = () => {
        if (!isValid(row)) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_FORM_INVALID, color: "error" });
            return;
        }

        const options = { row };
        callback(true, options);
    };

    return (
        <Box className="box">
            <Grid container spacing={1}>
                <Grid item xs={6} sm={6}>
                    <CustomInput name="type" row={row} onChange={onChange} label="Type" select={COOKIE_TYPES} />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Stack direction="row" justifyContent="center" alignItems="center">
                        <CustomInput name="manual_use" row={row} onChange={onChange} label="Manually set as used" checkbox />
                        <Typography variant="body2" color="textSecondary">
                            {"Manually set to be used?"}
                        </Typography>
                    </Stack>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <CustomInput name="note" row={row} onChange={onChange} label="Note" multiline minRows={2} maxRows={5} />
                </Grid>
            </Grid>

            <CustomButton {...props} title={"Update cookie"} onClick={handleClick} className="button" fullWidth />
        </Box>
    );
}
